import { useCallback, useEffect, useState } from "react";
import { api } from "../api.js";
import { Notice, PageHeader, TabButton, TabList } from "../components/ui.jsx";
import AuditTab from "./platform-catalog/AuditTab.jsx";
import CompaniesTab from "./platform-catalog/CompaniesTab.jsx";
import FieldsTab from "./platform-catalog/FieldsTab.jsx";
import Metrics from "./platform-catalog/Metrics.jsx";
import PeopleTab from "./platform-catalog/PeopleTab.jsx";
import RunsTab from "./platform-catalog/RunsTab.jsx";

const TABS = [
  ["companies", "Companies", "companies"],
  ["people", "People", "people"],
  ["fields", "Global fields", "fields"],
  ["runs", "Retrieval runs", "runs"],
  ["audit", "Change history", "platform_changes"],
];

export default function PlatformCatalogPage() {
  const [tab, setTab] = useState("companies");
  const [state, setState] = useState({ loading: true, overview: {}, error: "" });

  const loadOverview = useCallback(async () => {
    setState((current) => ({ ...current, loading: true, error: "" }));
    try {
      const data = await api.platformCatalogOverview();
      setState({ loading: false, overview: data.overview, error: "" });
    } catch (error) {
      setState((current) => ({ ...current, loading: false, error: error.message }));
    }
  }, []);

  useEffect(() => { loadOverview(); }, [loadOverview]);

  return (
    <div className="grid gap-8">
      <PageHeader
        eyebrow="Platform administration"
        title="Global data catalog"
        description="Manage the reusable company and people data layer shared across RevPal customers. Tenant-private memories, lists, and outreach remain workspace-scoped."
      />
      {state.error && <Notice>{state.error}</Notice>}
      <Metrics overview={state.overview} loading={state.loading} />
      <div>
        <TabList label="Global catalog views">
          {TABS.map(([id, label, countKey]) => (
            <TabButton selected={tab === id} key={id} onClick={() => setTab(id)}>
              {label} <span className="ml-1 text-muted-foreground">{state.overview[countKey] ?? "—"}</span>
            </TabButton>
          ))}
        </TabList>
        <div className="pt-6">
          {tab === "companies" && <CompaniesTab />}
          {tab === "people" && <PeopleTab />}
          {tab === "fields" && <FieldsTab onChanged={loadOverview} />}
          {tab === "runs" && <RunsTab />}
          {tab === "audit" && <AuditTab />}
        </div>
      </div>
    </div>
  );
}
